import React, { Component } from "react";
import ImageAndWelcome from "../components/ImageAndWelcome";
import CityList from "../components/CityList";
import SearchCity from "../components/SearchCity";
import axios from "axios";
import {API} from '../config/config'

class Home extends Component {
  constructor() {
    super();
    this.state = {
      featuredCities: null,
      citiesResultSearch: null,
      cityKeywordSeacrh: "",
      keyword: '',
      showSubtitle: false
    };
  }
  changeKeywordHandler = event => {
    this.setState({
      keyword: event.target.value
    });
  };

  searchHandler = () => {
    let keyword = this.state.keyword;
    var url = `${API.zomato.baseUrl}/cities`

    axios
      .get(url, {
        headers: {
          "user-key": `${API.zomato.api_key}`
        },
        params: {
          q: keyword
        }
      })
      .then(({ data }) => {
        if (data.status === "success") {
          this.setState({
            citiesResultSearch: data.location_suggestions,
            keyword: '',
            cityKeywordSeacrh: keyword,
            showSubtitle: true
          });
        }
      })
      .catch(error => console.log(error));
  };

  getFeaturedCities = () => {
    var url = `${API.zomato.baseUrl}/cities`;
    axios
      .get(url, {
        headers: {
          "user-key": `${API.zomato.api_key}`
        },
        params: {
          city_ids: "74, 11052, 170"
        }
      })
      .then(({ data }) => {
        if (data.status === "success") {
          this.setState({ featuredCities: data.location_suggestions });
        }
      })
      .catch(error => console.log(error));
  };

  componentDidMount() {
    // this.getFeaturedCities()
  }

  render() {
    const cities = [
      { id: 74, name: "Jakarta", country_name: "Indonesia" },
      { id: 11052, name: "Bandung", country_name: "Indonesia" },
      { id: 170, name: "Bali", country_name: "Indonesia" }
    ];
    return (
      <>
        <ImageAndWelcome />
        <div className="container" style={{ marginTop: 30, marginBottom: 30 }}>
          <CityList
            title={"Featured Cities"}
            cities={cities}
          />
          <SearchCity
            value={this.state.keyword}
            onChange={this.changeKeywordHandler}
            onClickSearch={this.searchHandler}
          />
          {this.state.cityKeywordSeacrh !== '' && (
            <CityList
            title={"Search Result"}
            subtitle={this.state.cityKeywordSeacrh}
            cities={this.state.citiesResultSearch}
            showSubtitle={this.state.showSubtitle}
          />
          )}
        </div>
      </>
    );
  }
}

export default Home;
